module.exports = __webpack_public_path__ + "static/media/request_dest_pin.9d29f6a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/arrivaClick/images/request_dest_pin.svg
// module id = 563
// module chunks = 0